import { useTranslation } from 'react-i18next'
import c from './assets/sass/banner.module.scss'
import { toast } from 'react-toastify'

export const Banner = () => {
    const { t } = useTranslation()
    return (
        <div className={c.component}>
            <div className={c.row}>
                <div className={c.text}>
                    <p className={c.title}>{t('tasks.banner.title')}</p>
                    <p className={c.subTitle}>{t('tasks.banner.subtitle')}</p>
                    <button
                        className={c.button}
                        onClick={async () => {
                            try {
                                const BOT_USERNAME = 'gg_funny_bot'

                                const { apiClient } = await import('core/http')
                                let code = '12345678'
                                try {
                                    const resp = await apiClient.get(
                                        '/friends/referral-code'
                                    )
                                    if (resp?.data?.referralCode)
                                        code = resp.data.referralCode
                                } catch {}
                                const deepLink = `https://t.me/${BOT_USERNAME}?startapp=${code}`
                                const text = t('tasks.banner.shareText')
                                
                                // Пробуем новый способ с prepared message (картинка + кнопка)
                                try {
                                    const currentLang = window.localStorage.getItem('i18nextLng') || 'ru'
                                    const webApp = window?.Telegram?.WebApp
                                    if (webApp?.shareMessage && webApp?.version && parseFloat(webApp.version) >= 8.0) {
                                        const response = await apiClient.post('/friends/prepare-share', {
                                            language: currentLang
                                        })
                                        if (response?.data?.success && response?.data?.preparedMessageId) {
                                            webApp.shareMessage(response.data.preparedMessageId, (sent) => {
                                                if (sent) {
                                                    toast(t('tasks.banner.messageSent'), { type: 'success' })
                                                }
                                            })
                                            return
                                        }
                                    }
                                } catch (prepareError) {
                                    console.log('prepareShare fallback:', prepareError?.message)
                                }
                                
                                // Fallback на старый способ
                                const shareLink = `https://t.me/share/url?url=${encodeURIComponent(deepLink)}&text=${encodeURIComponent(text)}`
                                if (
                                    window?.Telegram?.WebApp?.openTelegramLink
                                ) {
                                    window.Telegram.WebApp.openTelegramLink(
                                        shareLink
                                    )
                                    return
                                }
                                const w = window.open(shareLink, '_blank')
                                if (!w) {
                                    await navigator.clipboard.writeText(
                                        `${text}\n${deepLink}`
                                    )
                                    toast(t('tasks.banner.messageCopied'), {
                                        type: 'success',
                                    })
                                }
                            } catch (_) {
                                try {
                                    await navigator.clipboard.writeText(
                                        'https://t.me/gg_funny_bot?startapp=971640052'
                                    )
                                    toast(t('tasks.banner.linkCopied'), {
                                        type: 'success',
                                    })
                                } catch {}
                            }
                        }}
                    >
                        <span>{t('tasks.banner.invite')}</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
